import { lazy, Route } from '@tanstack/router'

import type { RegisterSearch } from './register'
import { rootRoute } from './root'

const RegisterWelcome = lazy(() => import('../pages/register-welcome'))

export const registerWelcomeRoute = new Route({
  getParentRoute: () => rootRoute,
  path: '/registrate-bienvenida',
  component: RegisterWelcome,
  validateSearch: (search: Record<string, unknown>): RegisterSearch => {
    return search
  },
})
